import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class VideoProps {
  @Inlet(Accepts.Video) public video?: Types["Video"];

  /**
   * Allow rotation is used for allowing rotation of the whole screen.
   *
   * Set to true specfically for Horizontal videos
   * @default false
   */
  @Inlet(Accepts.Boolean) public allowRotation?: Types["Boolean"];

  @Inlet(Accepts.ObjectAlignment) public alignment?: Types["ObjectAlignment"];

  @Inlet(Accepts.Subtitles) public subtitles?: Types["Subtitles"];

  @Inlet(Accepts.Boolean) public showContinueButton?: Types["Boolean"];
}

export const VideoDefinition = defineElement("video", VideoProps, {
  versionRequired: "0.8.0",
});
